<template>
  <div>
    <div
      class="upload_holder"
      :class="{ has_image: $parent.$parent[imageVarName] }"
    >
      <transition name="fade">
        <div
          v-if="!media && !load"
          class="upload_click"
          @click="$refs.upload.click()"
        >
          <img class="icon" src="@/assets/img/plus.svg" />
          <p>Click here to upload {{ title }}.</p>
        </div>
      </transition>

      <transition name="fade">
        <div v-if="!media && load" class="loading">
          <img class="loader" src="@/assets/img/loader.gif" />
          <p>loading...</p>
        </div>
      </transition>

      <transition name="fade">
        <div v-if="media && !load" class="success">
          <img v-if="media_type.includes('image')" :src="media" />
          <video v-if="media_type.includes('video')" :src="media"></video>
          <pdf
            v-if="media_type.includes('pdf')"
            class="pdf-renderer"
            :src="media"
            style="display: inline-block; width: 25%"
          ></pdf>
          <p @click="removeImage()" class="btn text_btn">
            Remove
          </p>
        </div>
      </transition>

      <input
        ref="upload"
        type="file"
        class="hide_upload"
        @change="uploadImage"
      />
    </div>
  </div>
</template>

<script>
import { db, storage } from "@/config/firebaseInit";

export default {
  props: ["media", "imageVarName", "title"],
  data() {
    return {
      load: false,
      media_type: "image"
    };
  },
  methods: {
    uploadImage(e) {
      let vm = this;
      this.upload = null;
      vm.load = null;
      setTimeout(function() {
        vm.load = true;
      }, 500);
      let media = e.target.files[0];
      let fileName = media.name;
      let fileSize = media.size;
      let type = media.type;
      let reader = new FileReader();
      this.media_type = type;

      reader.readAsDataURL(media);
      reader.onload = e => {
        let storageRef = storage.ref(`${vm.title}s/${Date.now()}`);
        let uploadTask = storageRef.put(media);

        uploadTask.on(
          "state_changed",
          snapshot => {},
          error => {
            vm.logoLoad = false;
            alert("could not upload logo, please try again.");
          },
          snapshot => {
            uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
              let media = {
                url: downloadURL,
                name: fileName,
                size: fileSize,
                date: new Date().getTime(),
                type: type
              };

              this.$emit("addMedia", downloadURL);
              vm.load = null;
              setTimeout(function() {
                vm.load = false;
              }, 500);
            });
          }
        );
      };
    },
    removeImage() {
      this.$emit("removeMedia");
    }
  }
};
</script>

<style lang="css" scoped>
.upload_holder {
  width: 100%;
  padding: 20px;
  background-color: #f7f7f7;
  max-width: 800px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  min-height: 300px;
}

.upload_holder.has_image {
  max-width: 100%;
}

.hide_upload {
  position: fixed;
  z-index: -2;
  width: 0 !important;
}

.upload_click,
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.upload_click .md-icon {
  font-size: 53px !important;
  opacity: 0.5;
}

.upload_click p {
  line-height: 1.3;
  max-width: 300px;
  text-align: center;
  opacity: 0.5;
  margin-top: 20px;
  margin-bottom: 0;
}

.icon {
  height: 40px;
  opacity: 0.2;
}

.rotate {
  font-size: 40px !important;
  -webkit-animation: loading 1s infinite linear;
}

.success p {
  text-align: center;
  margin-bottom: 0;
}

.success img {
  width: 100%;
  max-height: 100%;
}

@-webkit-keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loader {
  width: 75px !important;
}
</style>
